// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import history from './services/history';
import ScrollToTop from './ScrollToTop';
import { refreshBookshopStatus } from './services/bookshopStatus';

import {
  PackagingGuidelinesPage,
  TermsAndConditionsPage,
  ArrangeCollectionPage,
  FindParcelShopPage,
  ForgotPasswordPage,
  PrivacyPolicyPage,
  ChooseDeliveryPage,
  HowitworksPage,
  GuidelinesPage,
  RegisterPage,
  CheckoutPage,
  NotFoundPage,
  GetPaidPage,
  ContactPage,
  AccountPage,
  BasketPage,
  LoginPage,
  HomePage,
  FaqsPage,
  Fundraise,
} from './pages';

function App() {
  // An account promoted to a bookshop in COMS used to need a fresh login
  // before the shop interface appeared, because the flag was only ever read
  // from the login response. Re-checking here covers both the load and the
  // usual sequence: the switch is flipped in another tab, and coming back to
  // this one is what makes it take effect.
  useEffect(() => {
    const check = () => {
      // A rejected or failed check leaves the cached flag alone - see
      // refreshBookshopStatus.
      refreshBookshopStatus().catch(() => { });
    };

    check();

    const onVisibilityChange = () => {
      if (!document.hidden) {
        check();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  return (
    <Router history={history}>
      <ScrollToTop>
        <Switch>
          <Route exact path={'/'} component={HomePage} />
          <Route path={'/login'} component={LoginPage} />
          <Route path={'/register'} component={RegisterPage} />
          <Route path={'/account'} component={AccountPage} />
          <Route path={'/contact'} component={ContactPage} />
          <Route path={'/basket'} component={BasketPage} />
          <Route path={'/howitworks'} component={HowitworksPage} />
          <Route path={'/quality'} component={GuidelinesPage} />
          <Route path={'/help'} component={FaqsPage} />
          <Route path={'/packaging-guidelines'} component={PackagingGuidelinesPage} />
          <Route path={'/terms'} component={TermsAndConditionsPage} />
          <Route path={'/privacy'} component={PrivacyPolicyPage} />
          <Route path={'/checkout'} component={CheckoutPage} />
          <Route path={'/choose-delivery'} component={ChooseDeliveryPage} />
          <Route path={'/get-paid'} component={GetPaidPage} />
          <Route path={'/forgot-password'} component={ForgotPasswordPage} />
          <Route path={'/find-parcel-shop'} component={FindParcelShopPage} />
          <Route path={'/arrange-collection'} component={ArrangeCollectionPage} />
          <Route path={'/fundraise'} component={Fundraise} />
          {/* The voucher screens are routed under /account instead, so they
              render inside the account shell and keep its navigation tabs. */}
          <Route component={NotFoundPage} />
        </Switch>
      </ScrollToTop>
    </Router>
  );
}


export default App;

